var _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.031,
    height: 54.031
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-instagram_svg__a",
    x1: 0.5,
    y1: 0.008,
    x2: 0.5,
    y2: 0.998,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e09b3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c74c4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-instagram_svg__b",
    y1: -0.451,
    y2: 1.462,
    xlinkHref: "#social-instagram_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "social-instagram_svg__c",
    y1: -1.396,
    y2: 6.586,
    xlinkHref: "#social-instagram_svg__a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6326",
    d: "M37.935 0H16.1A16.114 16.114 0 000 16.1v21.835a16.114 16.114 0 0016.1 16.1h21.835a16.114 16.114 0 0016.1-16.1V16.1A16.114 16.114 0 0037.935 0zM48.6 37.935A10.661 10.661 0 0137.935 48.6H16.1A10.661 10.661 0 015.436 37.935V16.1A10.661 10.661 0 0116.1 5.436h21.835A10.661 10.661 0 0148.6 16.1v21.835z",
    fill: "url(#social-instagram_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 6327",
    d: "M146.974 133a13.974 13.974 0 1013.974 13.974A13.99 13.99 0 00146.974 133zm0 22.513a8.539 8.539 0 118.539-8.539 8.539 8.539 0 01-8.539 8.539z",
    transform: "translate(-119.959 -119.959)",
    fill: "url(#social-instagram_svg__b)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 1",
    cx: 3.349,
    cy: 3.349,
    r: 3.349,
    transform: "translate(37.668 9.798)",
    fill: "url(#social-instagram_svg__c)"
  })));
}
export default SvgSocialInstagram;